<template>
  <div class="card mgt-20px">
    <header class="header-card" >
      <p>{{ $t('adresseEmplacement.divers')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-3">
          <div>
            <p class="has-text-default is-italic">
              {{ $t('face.oldReference') }}
            </p>
            <p class="has-text-weight-bold">
              {{ face.ancienneReference }}
            </p>
          </div>
        </div>
        <div class="column">
          <div>
            <p class="has-text-default is-italic">
              {{ $t('face.information') }}
            </p>
            <p class="has-text-weight-bold">
              {{ face.information }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'InfoDivers',
  props: {
    face: {
      type: Object,
      required: true,
    },
  },
};
</script>
